import './styles.scss';
import { Badge } from 'reactstrap';

interface Props {
  className?: string;
}

export const AIExcludedBadge = ({ className = '' }: Props) => {
  return (
    <div className={`badge__wrapper d-inline-block ${className}`}>
      <Badge color='warning' className='outline px-4 py-1' pill>
        AI EXCLUDED
      </Badge>
    </div>
  );
};
